<template>
  <div class="element-list-estados">
    <div class="d-flex mb-2">
      <span class="text-msg-estados">{{ msgSelecionados }}</span>
      <div class="ml-auto">
        <b-button-group size="sm">
          <b-button @click="addAllEstado" variant="info"
            >Selecionar todos</b-button
          >
          <b-button @click="removeAllEstado" variant="danger"
            >Remover todos</b-button
          >
        </b-button-group>
      </div>
    </div>
    <b-row :class="[stateClass, sizeClass]">
      <b-col>
        <b-list-group class="list-estados">
          <b-list-group-item
            v-if="!value.length"
            class="d-flex list-estados-item"
          >
            {{ placeholder }}
          </b-list-group-item>

          <b-list-group-item
            v-for="(estado, key) in sortedValue"
            :key="key"
            class="d-flex list-estados-item"
          >
            {{ estado.sigla }} /
            {{ estado.nome }}

            <b-button
              @click="removeEstado(key)"
              variant="outline-danger"
              :disabled="disabled"
              class="ml-auto"
            >
              <font-awesome-icon icon="far fa-trash-alt" />
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col>
        <VueTypeaheadBootstrap
          v-model="search"
          @hit="addEstado"
          :data="estados"
          :serializer="(item) => item.sigla"
          placeholder="Buscar estados..."
          :class="[stateClass]"
          :showOnFocus="true"
          :size="size"
          :disabled="disabled"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import BaseButton from "@/components/BaseButton.vue";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { find, sortBy } from "lodash";
import * as storage from "@/modules/estados/storage";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {
      type: Array,
      default: [],
    },
    return_object: false,
    placeholder: {
      type: String,
      default: "Nenhum estado selecionado",
    },
    size: {
      type: String,
      default: "md",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap, BaseButton },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    search: "",
    estados: [],
  }),
  computed: {
    sizeClass() {
      return "form-control-" + this.size;
    },
    sortedValue() {
      return sortBy(this.value, ["sigla"]);
    },
    msgSelecionados() {
      let msg = this.value.length + " estados selecionados.";
      if (this.value.length == 0) {
        msg = "Nenhum estado selecionado";
      } else if (this.value.length == 1) {
        msg = "1 estado selecionado.";
      }
      return msg;
    },
  },
  methods: {
    ...mapActions("municipios", ["ActionGetAllEstados"]),
    addEstado(estado) {
      if (estado) {
        let has_uf = find(this.value, ["sigla", estado.sigla]);
        if (!has_uf) {
          this.value.push(estado);
        } else {
          this.$notifications.addNotification({
            message: "Este Estado ja foi selecionado",
            icon: "exclamation-triangle",
            type: "warning",
          });
        }
      }
      this.$nextTick(() => {
        this.search = "";
      });
    },
    addAllEstado() {
      this.value.splice(0, this.value.length);
      this.value.push(...this.estados);
    },
    removeAllEstado() {
      this.value.splice(0, this.value.length);
    },
    removeEstado(index) {
      this.value.splice(index, 1);
    },
  },
  async created() {
    this.estados = await this.ActionGetAllEstados();
  },
};
</script>

<style lang="scss">
.element-list-estados {
  position: relative;

  .form-control-custom {
    margin-left: 0 !important;
    padding-left: 0 !important;
    padding-top: 0 !important;

    .form-control {
      border: none !important;
      background: transparent !important;
    }
  }

  .list-estados {
    max-height: 200px;
    overflow-y: auto;

    .list-estados-item {
      padding: 0.5rem !important;
      line-height: 30px;

      &:hover {
        .btn {
          opacity: 1;
        }
      }
    }

    .btn {
      opacity: 0;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      padding: 0 !important;

      font-size: 1rem;
      padding: auto !important;

      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.5s !important;
    }
  }

  .text-msg-estados {
    color: #999;
    font-size: 0.9em;
    font-style: italic;
  }
}
</style>
